import React, { createContext, useContext, useMemo } from "react";
import { useLocation } from "react-router-dom";
import { BRANDS } from "@/lib/brands";

const BrandContext = createContext(null);

const resolveBrandSlug = (pathname) => {
  // 1. Hostname takes priority (so dalesrecycling.com → Dale's, queencitymetal.com → QCM)
  if (typeof window !== "undefined" && window.location?.hostname) {
    const host = window.location.hostname.toLowerCase();
    if (host.includes("dalesrecycling")) return "dales";
    if (host.includes("queencitymetal")) return "qcm";
  }
  // 2. Fallback to path-based routing for preview / shared deployments
  if (pathname.startsWith("/dales")) return "dales";
  return "qcm";
};

export const BrandProvider = ({ children }) => {
  const location = useLocation();
  const value = useMemo(() => {
    const slug = resolveBrandSlug(location.pathname);
    const active = BRANDS[slug];
    const sister = BRANDS[active.sister_slug];
    return { brand: active, sister };
  }, [location.pathname]);

  return (
    <BrandContext.Provider value={value}>{children}</BrandContext.Provider>
  );
};

export const useBrand = () => {
  const ctx = useContext(BrandContext);
  if (!ctx) throw new Error("useBrand must be used within BrandProvider");
  return ctx;
};
